import { DatePicker, Form, notification, Table, Select, Pagination } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import * as Actions from '../../../../../libs/actions';
import * as StatisticService from '../../../../../services/statisticService';
import * as PrintService from '../../../../../services/printService';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import * as ConfigService from '../../../../../services/configService';
import * as UsersService from '../../../../../services/usersService';
import { connect } from 'react-redux';
const { RangePicker } = DatePicker;
const { Option } = Select;

class theodichvuBN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ngay: [moment(), moment()],
            dataSource: [],
            tongthucthu: 0,
            tongbn: 0,
            listSite: [],
            chinhanh: '',
            isMultisite: false,
            page: 1,
            size: 10,
            totalRecords: 0,
        };
    }

    componentDidMount() {
        UsersService.CheckPremissionMultisite().then(result => {
            if (result.isSuccess) {
                this.setState({
                    isMultisite: result.item
                });
            }
        });
        this.GetListSite();
        this.LoadThongKeDoanhSo(1);
    }

    
    GetListSite() {
        ConfigService.GetListSite(false).then(result => {
            if (result.isSuccess) {
                this.setState({ listSite: result.data });
            } else {
                this.setState({ listSite: [] });
            }
        }).catch(err => {
        })
    }
    LoadThongKeDoanhSo(page = this.state.page, size = this.state.size) {
        Actions.setLoading(true);
        StatisticService.ThongKeTheoDichVuBenhNhanPerformance(this.props.ngay !== undefined ? this.props.ngay[0].format('YYYY-MM-DD HH:mm') : this.state.ngay[0].format('YYYY-MM-DD 00:00'),
        this.props.ngay !== undefined ? this.props.ngay[1].format('YYYY-MM-DD HH:mm') : this.state.ngay[1].format('YYYY-MM-DD 23:59'),
        this.props.paymenttype === undefined ? 0 : this.props.paymenttype, this.props.coporator === undefined ? "" : this.props.coporator, '', '', this.props.siteid, page, size).then(result => {
            if (result.isSuccess) {
                result.data.forEach(x => { if (x.mavp === null || x.mavp === ''); });
                this.setState({
                    dataSource: result.data,
                    totalRecords: result.totalRecords,
                    page: page, size: size
                });
            }
            Actions.setLoading(false);
        }).catch(err => {
            Actions.setLoading(false);
            notification.warning({ message: 'Tải dữ liệu bị lỗi' })
        })
    }
    ExportThongKeDoanhSo(props) {
        Actions.setLoading(true);
        StatisticService.ExportThongKeDichVuTheoNguonKhachHang(this.props.ngay !== undefined ? this.props.ngay[0].format('YYYY-MM-DD HH:mm') : this.state.ngay[0].format('YYYY-MM-DD 00:00'),
                this.props.ngay !== undefined ? this.props.ngay[1].format('YYYY-MM-DD HH:mm') : this.state.ngay[1].format('YYYY-MM-DD 23:59'),
                this.props.paymenttype, this.props.siteid)
            .then((response) => {
                response.blob().then((blob) => {
                    let url = window.URL.createObjectURL(blob);
                    this._hiddenLink.href = url;
                    this._hiddenLink.download = "ThongKeDichVuTheoNguonKhachHang";
                    this._hiddenLink.click();
                })
                Actions.setLoading(false);
            }).catch(err => {
                Actions.setLoading(false);
            })
    }
    CheckNumberMoney(num) {
        if (num < 0)
            return 0;
        return num;
    }
    GetAllInvoices = (data) => {
        if (data.sobienlai)
            return data.sobienlai;
        else return "";
    }
    render() {
        const columns = [
            {
                title: 'STT',
                width: 50,
                align: 'center',
                render: (text, record, index) => {
                    if (record.mavp === null || record.mavp === '') {
                        return {
                            children: <strong style={{ fontSize: '15px', float: 'left', marginLeft: '5px' }}>Biên lai: {this.GetAllInvoices(record)} - {record.tenbn}</strong>,
                            props: {
                                colSpan: 12,
                            }
                        }
                    }
                    else {
                        return {
                            children: <span>{this.state.dataSource.filter(x => x.sobienlai === record.sobienlai).indexOf(record)}</span>,
                            props: {
                                colSpan: 1,
                            }
                        }
                    }
                },
            },
            {
                title: 'Sản phẩm/Dịch vụ',
                dataIndex: 'tenvp',
                key: 'tenvp',
                render: (text, record, index) => {
                    if (record.mavp === null || record.mavp === '') {
                        return {
                            children: <span>{ }</span>,
                            props: {
                                colSpan: 0,
                            }
                        }
                    }
                    else {
                        return {
                            children: <span>{record.tenvp}</span>,
                            props: {
                                colSpan: 1,
                            }
                        }
                    }
                },

            },
            {
                title: 'Số lượng',
                dataIndex: 'soluong',
                key: 'soluong',
                align: 'center',
                width: 80,
                render: (text, record, index) => {
                    if (record.mavp === null || record.mavp === '') {
                        return {
                            children: <span>{ }</span>,
                            props: {
                                colSpan: 0,
                            }
                        }
                    }
                    else {
                        return {
                            children: <span>{record.soluong}</span>,
                            props: {
                                colSpan: 1,
                            }
                        }
                    }
                },
            },
            {
                title: 'Ngày lập',
                dataIndex: 'ngay',
                key: 'ngay',
                width: 120,
                render: (text, record, index) => {
                    if (record.mavp === null || record.mavp === '') {
                        return {
                            children: <span></span>,
                            props: {
                                colSpan: 0,
                            }
                        }
                    }
                    else {
                        return {
                            children: <span>{text}</span>,
                            props: {
                                colSpan: 1,
                            }
                        }
                    }
                },
            },
            {
                title: 'Nguồn khách hàng',
                dataIndex: 'tendonvi',
                key: 'tendonvi',
                width: 200,
                render: (text, record, index) => {
                    if (record.mavp === null || record.mavp === '') {
                        return {
                            children: <span></span>,
                            props: {
                                colSpan: 0,
                            }
                        }
                    }
                    else {
                        return {
                            children: <span>{text}</span>,
                            props: {
                                colSpan: 1,
                            }
                        }
                    }
                },
            },

        ]
        return (
            <React.Fragment>
                <div style={{ padding: "0px", display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <a href="#download" style={{ visibility: "hidden", display: 'none' }} ref={(c) => { this._hiddenLink = c }} >download</a>
                    <div className="row no-gutters" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 10, paddingBottom: 15 }}>
                        {/* {this.state.isMultisite === true &&
                            <div><Form.Item>
                                <Select
                                    style={{ width: '200px' }}
                                    showSearch
                                    allowClear={false}
                                    value={this.state.chinhanh}
                                    onChange={(e) => {
                                        this.setState({ chinhanh: e })
                                    }}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key={-1} value={''}>Chi nhánh</Option>
                                    {this.state.listSite.map((row, index) => {
                                        return (
                                            <Option key={index} value={row.id}>{row.ma}</Option>
                                        )
                                    })}
                                </Select></Form.Item>
                            </div>
                        } */}
                        {this.props.doanhso === true &&
                        <>
                            <div className="col-auto">
                                <Form.Item>
                                    <RangePicker locale={viVN} disabledDate={current => { return current && current >= moment() }}
                                        allowClear={false} format="DD-MM-YYYY" value={this.state.ngay}
                                        placeholder={['DD-MM-YYYY', 'DD-MM-YYYY']}
                                        onChange={(value => this.setState({ ngay: value }, () => { this.LoadThongKeDoanhSo(1) }))}
                                    />
                                </Form.Item>
                            </div>
                            <Form.Item>
                                <button className="btn btn-color" onClick={() => { this.LoadThongKeDoanhSo(1) }}><i style={{ marginRight: 5 }} className="fa fa-search" />Tìm</button>
                            </Form.Item>
                        </>
                        }
                        <Form.Item>
                            <button className="btn btn-color" style={{ margin: "0px 10px 0 5px" }} onClick={() => { this.ExportThongKeDoanhSo() }}> <i style={{ marginRight: 5 }} className="fas fa-download" />Xuất excel</button>
                        </Form.Item>
                    </div>
                    
                    <div style={{ height: 'calc(100% - 120px)' }}>
                        <Table
                            pagination={false}
                            scroll={{ x: 'max-content', y: 0 }}
                            dataSource={this.state.dataSource} columns={columns} rowKey={(row, index) => index} />
                    </div>
                    <Pagination
                        style={{
                            marginTop: 10, textAlignLast: 'center'
                        }}
                        total={this.state.totalRecords}
                        current={this.state.page || 1}
                        size={this.state.size || 10}
                        showTotal={(total) => `Tổng: ${total}`}
                        showSizeChanger={true}
                        onChange={(page, size) => {
                            this.setState({
                                page: page,
                                size: size,
                            }, () => this.LoadThongKeDoanhSo(page, size));
                        }}
                        onShowSizeChange={(page, size) => {
                            this.setState({
                                currentPage: 1,
                                currentSize: size,
                            }, () => this.LoadThongKeDoanhSo(1, size));
                        }}
                    />
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        siteid: state.global.siteid,
        siteCode: state.global.siteCode,
        availableSites: state.global.availableSites,
    })
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(theodichvuBN);